import { render, staticRenderFns } from "./feedback-modal.vue?vue&type=template&id=15873556&scoped=true&"
import script from "./feedback-modal.vue?vue&type=script&lang=js&"
export * from "./feedback-modal.vue?vue&type=script&lang=js&"
import style0 from "./feedback-modal.vue?vue&type=style&index=0&id=15873556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15873556",
  null
  
)

export default component.exports